<template>
  <div>
    <notifications-wrapper position="bottom right" width="20%" />
    <top-navbar />
    <nuxt />
    <custom-footer />
    <image-zoom-modal />
    <share-images-modal />
    <resource-notifications-create-modal />
  </div>
</template>
<script>
import TopNavbar from '@/components/commons/TopNavbar.vue'
import CustomFooter from '@/components/commons/CustomFooter.vue'
import NotificationsWrapper from '@/components/commons/NotificationsWrapper.vue'
import ImageZoomModal from '@/components/commons/ImageZoomModal.vue'
import ShareImagesModal from '@/components/ShareImagesModal.vue'
import ResourceNotificationsCreateModal from '@/components/ResourceNotifications/CreateModal.vue'
import { mediaListFromLocalStorage } from '@/store/share_images_cart'
import { subscribeChannels, unsubscribeChannels } from '@/utils/websocket_channels'
import EventBus, { EVENTS } from '@/utils/eventBus'

export default {
  components: {
    TopNavbar,
    CustomFooter,
    NotificationsWrapper,
    ImageZoomModal,
    ShareImagesModal,
    ResourceNotificationsCreateModal
  },
  middleware: ['redirect_after_login', 'auth', 'check_authorization'],
  channels: {
    ResourcesChannel: {
      received({ data }) { this.$store.commit('editorial/updatePublication', data) }
    },
    WebsitePagesChannel: {
      received({ data }) { this.handleWebsitePageUpdate(data) }
    }
  },
  mounted() {
    subscribeChannels(this.$cable) 
    this.$store.commit('share_images_cart/setMediaList', mediaListFromLocalStorage())
  },
  beforeDestroy() { unsubscribeChannels(this.$cable) },
  methods: {
    handleWebsitePageUpdate({ page, status, resource }) {
      const alertInfo = { page_number: page + 1, resource_title: resource.title }
      if (status == 'crawled')
        this.$_notify({ text: this.$t('editorials.messages.websitePageAdded', alertInfo), type: 'success' })
      else if (status == 'failed') 
        this.$_notify({ text: this.$t('editorials.messages.websitePageError', alertInfo), type: 'danger' })

      EventBus.$emit(EVENTS.WEBSITE_PAGE_ADDED, resource.id)
    }
  }
}
</script>
